// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 17:53:58

export default {
  "id": "knee-case-simulator",
  "slug": "knee-case-simulator",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/70d9006bafe44b4ea055f35ff3004a8a-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/70d9006bafe44b4ea055f35ff3004a8a/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Knee Case Simulator",
      "description": "Knee Case Simulator is a delightful beauty and doctor simulation game where you get to showcase your medical skills and fashion sense! Help Tiara recover from her knee injury and give her a stylish makeover once she's feeling better.",
      "instructions": "Use MOUSE to play the game.",
      "genres": [
        "Dress-up",
        "Simulation"
      ],
      "tags": [
        "doctor",
        "girls",
        "hospital"
      ]
    },
    "zh-CN": {
      "title": "膝盖案例模拟器",
      "description": "膝关节模拟器是一款令人愉悦的美容与医生模拟游戏，在这里你可以展示你的医疗技能和时尚感！帮助蒂亚从膝盖受伤中恢复，并在她感觉好转后给她一个时尚的改造。",
      "instructions": "使用鼠标来玩游戏。",
      "genres": [
        "装扮",
        "模拟"
      ],
      "tags": [
        "医生",
        "女孩",
        "医院"
      ]
    },
    "zh-TW": {
      "title": "膝蓋案例模擬器",
      "description": "膝蓋案例模擬器是一款令人愉快的醫美模擬遊戲，您可以在遊戲中展現您的醫療技巧和時尚感覺！幫助蒂亞拉從膝蓋受傷中恢復過來，並在她感覺好一點時給她來個時尚的變身。",
      "instructions": "使用滑鼠玩遊戲。",
      "genres": [
        "裝飾",
        "模擬"
      ],
      "tags": [
        "醫生",
        "女孩們",
        "醫院"
      ]
    },
    "zh-HK": {
      "title": "膝蓋案例模擬器",
      "description": "膝蓋病例模擬器是一款令人歡愉的美容及醫生模擬遊戲，讓您得以展現您的醫療技巧及時尚感！幫助Tiara從膝蓋受傷中康復，並在她恢復健康後給她來個時尚變身！",
      "instructions": "使用滑鼠遊玩遊戲。",
      "genres": [
        "裝飾遊戲",
        "模擬遊戲"
      ],
      "tags": [
        "醫生",
        "少女",
        "醫院"
      ]
    },
    "ja": {
      "title": "膝関節シミュレーター",
      "description": "膝蓋シミュレーターは、あなたが医療技術とファッションセンスを披露できる魅力的な医療シミュレーションゲームです！ティアラが膝の怪我から回復し、快くなら次第、スタイリッシュなメイクオーバーを施してあげましょう！",
      "instructions": "ゲームをプレイするにはマウスを使用してください。",
      "genres": [
        "ドレスアップ",
        "シミュレーション"
      ],
      "tags": [
        "医師",
        "少女",
        "病院"
      ]
    },
    "ko": {
      "title": "무릎 사롤 시뮬레이터",
      "description": "膝关节케이스 시뮬레이터는 의료 기술과 패션 감각을 발휘할 수 있는 즐거운 미용과 의사 시뮬레이션 게임입니다! 티아라가 무릎 부상에서 회복되면 그녀를 스타일리시하게 변신해 주세요!",
      "instructions": "게임을 플레이하려면 마우스를 사용하세요.",
      "genres": [
        "의상 변신",
        "시뮬레이션"
      ],
      "tags": [
        "의사",
        "소녀",
        "병원"
      ]
    },
    "fr": {
      "title": "Simulateur de Casque de Genou",
      "description": "Knee Case Simulator est un jeu de beauté et de simulation médicale delightant où vous pouvez démontrer vos compétences médicales et votre sens de la mode ! Aidez Tiara à se rétablir de son blessure au genou et lui donnez une transformation stylée une fois qu'elle se sent mieux.",
      "instructions": "Utilisez la SOURIS pour jouer au jeu.",
      "genres": [
        "Dress-up",
        "Simulation"
      ],
      "tags": [
        "Docteur",
        "filles",
        "hôpital"
      ]
    }
  }
};
